import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Image } from "react-bootstrap"

import certificatCoherence from "../images/diplomes/certificat-coherence.jpg"

const coherenceCardiaque = () => {
  return (
    <Layout>
      <SEO title="Cohérence cardiaque" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h2>Cohérence cardiaque</h2>
          </div>
          <div className="col-md-12 mb-3">
            <p>
              Parmi les différentes pratiques de respiration que je vous propose
              figure l’exercice de la cohérence cardiaque, qui s’intègre
              parfaitement dans les séances de sophrologie. Cette exercice est
              très simple et très complémentaire à la pratique de la
              sophrologie.
              <br />
              <br />
              Le concept de cohérence cardiaque est issu des recherches
              médicales en neurosciences et en neuro-cardiologie. Il est apparu
              aux Etats-Unis il y a une quinzaine d’années, et son impact
              bénéfique sur la santé a été mis en lumière par l’Institut
              HeartMath.
              <br />
              <br />
              La cohérence cardiaque est un état particulier de la variabilité
              de la fréquence cardiaque qui permet d’équilibrer le système
              nerveux autonome et la gestion émotionnelle. Cet état particulier
              s’accompagne de nombreux effets physiologiques, biologiques et
              psychologiques, en particulier dans le domaine du stress et de ses
              effets sur l’organisme.
              <br />
              <br />
              La cohérence cardiaque permet de se rééquilibrer et de revenir à
              la stabilité (normalité) lorsqu’il y a perturbation physiologique
              induite par le stress. Ainsi la pratique de la cohérence cardiaque
              permet d’intégrer une régulation interne dans tout le système de
              la personne. Elle permet également de réduire l’effet des pensées
              intrusives négatives et de les neutraliser de façon mécanique et
              automatique, sans effort volontaire pour gérer les pensées. Il
              s’agit donc d’un outil privilégié pour la gestion du stress et
              pour réduire l’anxiété.
              <br />
              <br />
              La cohérence cardiaque est une pratique individuelle qui se base
              sur des exercices simples de respiration consciente. C’est une
              technique de focalisation de l’attention sur la respiration. Cette
              pratique à la portée de tous se met en place par des exercices
              quotidiens, progressifs et gradués.
              <br />
              <br />
              Un logiciel spécifique, muni d’un guide visuel et auditif, est
              désormais à votre disposition au cabinet pour découvrir et vivre
              cette respiration, tout en visualisant votre fréquence cardiaque
              durant la séance.Le principe est simple : un capteur de pouls,
              relié à un ordinateur, est placé sur le doigt ou sur le lobe de
              l’oreille, il collecte la fréquence cardiaque en temps réel et
              transmet les données à un logiciel qui traduit les données sous
              une forme graphique.
              <br />
              <br />
              Le logiciel propose un guide respiratoire visuel et auditif ainsi
              qu’une courbe permettant de visualiser la fréquence cardiaque en
              temps réel. La pratique de la respiration guidée au moyen du
              métronome visuel ou auditif, via ce logiciel, permet de visualiser
              l’état de cohérence cardiaque.
              <br />
              <br />
              <em>
                La respiration de la cohérence cardiaque figure en tête des dix
                règles d’or de la Fédération Française de Cardiologie pour
                prévenir les risques Cardio-Vasculaires. Je vous invite à les
                consulter sur le site{" "}
                <a
                  href="https://www.fedecardio.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.fedecardio.org
                </a>{" "}
                (brochure « Coeur et stress »).
              </em>
              <br />
              <br />
              <strong>
                NB : les données produites par ce logiciel ne peuvent pas être
                utilisées à des fins diagnostiques.
              </strong>
            </p>
            <div className="col-md-12">
              <Image
                className="d-block mx-auto"
                src={certificatCoherence}
                alt="Certificat Cohérence Cardiaque"
                fluid
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default coherenceCardiaque
